import { COMPANION_EXTENSIONS, OGR_FORMATS } from '@app/modules/Home/Data/constants/ogr.formats'

export type FileGroup = {
  primary: File
  companions: File[]
  allFiles: File[]
}

export function getExt(file: File): string {
  return file.name.split('.').pop()?.toLowerCase() ?? ''
}

export function getBaseName(file: File): string {
  const parts = file.name.split('.')
  parts.pop()
  return parts.join('.').toLowerCase()
}

export function groupFiles(files: File[]): FileGroup {
  const primaries = files.filter((f) => !COMPANION_EXTENSIONS.has(getExt(f)))
  const companions = files.filter((f) => COMPANION_EXTENSIONS.has(getExt(f)))

  if (primaries.length === 0) {
    throw new Error('No primary file found in selection.')
  }
  if (primaries.length > 1) {
    throw new Error(
      `Multiple primary files selected (${primaries.map((f) => f.name).join(', ')}). Select files for one dataset at a time.`,
    )
  }

  const primary = primaries[0]
  const primaryBase = getBaseName(primary)
  const mismatched = companions.filter((f) => getBaseName(f) !== primaryBase)

  if (mismatched.length > 0) {
    throw new Error(
      `Companion files do not match the primary file basename: ${mismatched.map((f) => f.name).join(', ')}`,
    )
  }

  return { primary, companions, allFiles: [primary, ...companions] }
}

export function getMissingCompanions(files: File[]): string[] {
  const exts = new Set(files.map(getExt))
  for (const format of OGR_FORMATS) {
    if (format.type === 'primary' && exts.has(format.ext)) {
      return format.required.filter((req) => !exts.has(req))
    }
  }
  return []
}
